/**
 * Pepal Global JS
 * Vanilla JS implementation for state management and basic interactions.
 */

document.addEventListener('DOMContentLoaded', () => {
  // Mobile Menu Toggle
  const mobileMenuToggle = document.querySelector('[data-mobile-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  
  if (mobileMenuToggle && mobileMenu) {
    mobileMenuToggle.addEventListener('click', () => {
      mobileMenu.classList.toggle('hidden');
    });
  }

  // Floating Navbar scroll interaction
  const floatingNav = document.querySelector('[data-floating-nav]');
  if (floatingNav) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 400) {
        floatingNav.classList.remove('opacity-0', 'pointer-events-none', 'translate-y-4');
        floatingNav.classList.add('opacity-100', 'pointer-events-auto', 'translate-y-0');
      } else {
        floatingNav.classList.add('opacity-0', 'pointer-events-none', 'translate-y-4');
        floatingNav.classList.remove('opacity-100', 'pointer-events-auto', 'translate-y-0');
      }
    });
  }

  // Session Storage Example (Cart/State persistence wrapper)
  window.PepalStore = {
    set: (key, value) => sessionStorage.setItem(key, JSON.stringify(value)),
    get: (key) => {
      const item = sessionStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    }
  };
});
